"use client";

import styled from "styled-components";

//Types
import type { CustomInputProps } from "@/types";
import { NumericFormat } from "react-number-format";

export const TextareaComponent = styled.textarea<CustomInputProps>`
  background: transparent;
  width: 100%;
  min-height: 100px;
  border: 1px solid var(--borderColor);
  border-radius: 7px;
  box-shadow: none;
  padding: 10px;
  font-family: "Roboto Light";

  font-size: 14px;
  line-height: 24px;
  font-weight: normal;
  color: var(--titleColor);
  resize: vertical;

  &:focus {
    border-color: var(--primaryAndPurple);
    box-shadow: 0px 4px 8px 1px var(--colorShadow);
    outline: none;
  }

  &::placeholder {
    color: var(--placeholderColor);
  }

  ${({ $hasShadow }) =>
    $hasShadow &&
    `
        box-shadow: 0px 4px 8px 1px var(--colorShadow);
        &:focus {
            box-shadow: 0px 4px 8px 1px var(--colorShadow);
        }
    `}

  ${({ validation }) =>
    validation?.type === "error" &&
    `
        border-color: var(--red)!important;
    `}
`;

export const ErrorMessage = styled.span`
  font-size: 12px;
  display: block;
  color: var(--red);
`;
